import React from 'react';
import DeleteIcon from '../adminIcons/DeleteIcon.svg'
import { useDispatch } from 'react-redux';
import { deleteCategoryTag } from '../../actions/AdminCategoryActions';

const CategoryTagItem = (props) => {

    const dispatch = useDispatch()
    const deleteHandler = (tag) => {
        var answer = window.confirm("Do you really want to delete tag?");
        if (answer) {
            dispatch(deleteCategoryTag(tag.id, props.category_id))
        }
    }

    return (
        <div className='col-12 bg-warning border-bottom border-success d-flex align-items-center p-2'
    
        >
            <div className = 'd-flex w-100'>
                <div className = "text-white overflow-hidden text-center col-10">{props.tag.title}</div>
                <div className='d-flex justify-content-center col-2'
                    style={{gap:"10px"}}>
                    <img 
                        src = {DeleteIcon} alt = "" 
                        role='button'
                        onClick={()=>deleteHandler(props.tag)}
                    />
                </div>
            </div>
        </div>
    );
};

export default CategoryTagItem;